import { Guid } from 'guid-typescript';

export class BulkEditModel {
  id: Guid;
  date: string;
  reference: string;
  account: string;
  fundId: Guid;
  contactNumber: string;
  referenceNo: number;
  receipt: string;
  payment: string;
  isSelected: boolean;
  invoiceTypeId: number;
  accountValue: any;
  journalItemId?:Guid;
  isFeeExpenseAccount:boolean;
  isPeriodLocked?: boolean;
  moduleId?: any;
}

export class SaveBulkEditModel {
  id?: Guid;
  invoiceTypeId?: number;
  bookAccountId?: Guid;
  fundId?: Guid | any;
  reference?: string;
  companyId?: string;
  journalItemId?:Guid;
  isFeeExpenseAccount:boolean;
}
